import React from "react";

import { MODEL_LIST } from "../scene/ModelLibrary";

export default function ModelSelector({ modelId, setModelId }) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "6px",
      }}
    >
      {MODEL_LIST.map((model) => (
        <button
          key={model.id}
          type="button"

          className={
            modelId === model.id
              ? "reconstruction-button active"
              : "reconstruction-button"
          }

          onClick={() => setModelId(model.id)}
        >
          {model.name}
        </button>
      ))}
    </div>
  );
}
